module.exports = __webpack_public_path__ + "img/caroselPlay.f7c29111.svg";